
function FlatCounter({height, width, left, top, draw_back}: 
    {height: number, width: number, left: number, top: number, draw_back:boolean,
        stroke?: string, fill?:string
    }){
    const right = left + width
    const bottom = top + height
    if (draw_back){
        return (
            <path className="counter" d={`
                     M${left},${top}
                     A${width},20 0 0,0 ${right},${top}
                     A${width},20 0 0,0 ${left},${top}
                     L${left},${bottom}
                     A${width},20,0 0,0 ${right},${bottom}
                     L${right},${top}             
                     `}/>
            )    
    }
    else {
        return (
            <path className="counter" d={`
                    M${left},${top} 
                    A${width},20 0 0,0 ${right},${top}
                    M${left},${top}
                    L${left},${bottom}
                    A${width},20,0 0,0 ${right},${bottom}
                    L${right},${top}             
                    `}/>
            )
    }
}

export default function CounterStack({size}: {size: number}){
    const MAX_COUNTERS = 5
    const COUNTER_HEIGHT = 25
    const COUNTER_WIDTH = 96
    let ncounters = Math.max(Math.min(size, MAX_COUNTERS),0)
    const total_height = (MAX_COUNTERS + 1) * COUNTER_HEIGHT
    return (
        <svg width={100} height={total_height} viewBox={`0 0 100 ${total_height}`} >
            {
        [...Array(ncounters).keys()].map( (i) => {
            return <FlatCounter 
            height={COUNTER_HEIGHT} 
            width={COUNTER_WIDTH} 
            left={2} top={total_height - (COUNTER_HEIGHT * (i + 1.5)) }
            draw_back={i==ncounters-1} 
            key={i}/>
        })
    }
        </svg>
    )
    
}